import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { RegistroComponent } from './pages/registro/registro.component';
import { LoginComponent } from './pages/login/login.component';
import { LegalesComponent } from './pages/legales/legales.component';
import { PresentacionComponent } from './pages/presentacion/presentacion.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LobbyComponent } from './pages/lobby/lobby.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate:[ AuthGuard] },
  { path: 'lobby', component: LobbyComponent },
  { path: 'prese', component: PresentacionComponent },
  { path: 'registro', component: RegistroComponent },
  { path: 'login', component: LoginComponent },
  { path: 'legales', component: LegalesComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'ytube', 
    loadChildren: () => import('./pages/ytube/ytube.module')
      .then(m => m.YtubeModule), canActivate:[ AuthGuard] },
  { path: '**', pathMatch: 'full', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { 
    useHash:true, 
    onSameUrlNavigation: 'reload', 
    scrollPositionRestoration: 'top', 
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
